export default __webpack_public_path__ + "static/media/SL.463c6769.jpg";